import { themedUseStyletron } from '../../../theme/customTheme'
import { ISensorDigitalInformation } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { Icon } from './Icon';

export function OverviewPanel(props: ISensorDigitalInformation) {
    const [, theme] = themedUseStyletron();

    return (
        <OverviewPanelWrapper icon={<Icon schema={props.schema} color={theme.colors.backgroundPrimary} size='100%' />} small {...props}>
            <Icon schema={props.schema} color={props.isErr ? theme.colors.accent300 : theme.colors.contentTertiary} size='40px' />
        </OverviewPanelWrapper>
    );
}